// @ts-nocheck
/* eslint-disable */
/* istanbul ignore file */

const trackingEnabled =
  process.env.NEXT_PUBLIC_TENANT === 'lifepoints' ||
  (process.env.NEXT_PUBLIC_TENANT === 'mobiworkx' &&
    (process.env.NODE_ENV === 'production' || process.env.NEXT_PUBLIC_ALWAYS_TRACK)); // NEXT_PUBLIC_ALWAYS_TRACK is for ease of development

export function initializeGTM() {
  if (trackingEnabled && process.env.NEXT_PUBLIC_GTM_ID) {
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src =
        'https://www.googletagmanager.com/gtm.js?id=' +
        i +
        dl +
        `&gtm_auth=${process.env.NEXT_PUBLIC_GTM_AUTH}&gtm_preview=env-${process.env.NEXT_PUBLIC_GTM_ENV_NUMBER}&gtm_cookies_win=x`;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', process.env.NEXT_PUBLIC_GTM_ID);
  }
}
